// hooks/usePoolAPI.js
import { useState } from 'react';
import { ApiUrl } from '../../../utils/ApiUrl';

const usePoolAPI = () => {
    const [isSavingPool, setIsSavingPool] = useState(false);
    const [saveError, setSaveError] = useState(null);

    const savePoolToBackend = async (formData, account, transactionHash, unifarmAddress, gasFees = "0.05") => {
        setIsSavingPool(true);
        setSaveError(null);

        try {
            const formDataToSend = new FormData();

            // Only append fields that are present/not empty
            if (formData.logo) {
                formDataToSend.append('projectLogo', formData.logo);
            }

            if (formData.rewardToken) {
                formDataToSend.append('rewardToken', formData.rewardToken?.toLowerCase());
            }
            if (formData.symbol) {
                formDataToSend.append('symbol', formData.symbol);
            }
            if (formData.tokenDecimals) {
                formDataToSend.append('tokenDecimals', formData.tokenDecimals);
            }
            if (formData.chain) {
                formDataToSend.append('chain', formData.chain);
            }

            if (formData.projectName) {
                formDataToSend.append('projectName', formData.projectName);
            }

            if (formData.tagline) {
                formDataToSend.append('tagline', formData.tagline);
            }

            if (formData.poolDescription) {
                formDataToSend.append('poolDescription', formData.poolDescription);
            }

            if (formData.website) {
                formDataToSend.append('socials[website]', formData.website);
            }

            if (formData.twitter) {
                formDataToSend.append('socials[twitter]', formData.twitter);
            }

            if (formData.instagram) {
                formDataToSend.append('socials[instagram]', formData.instagram);
            }

            if (formData.discord) {
                formDataToSend.append('socials[discord]', formData.discord);
            }

            if (formData.totalRewards) {
                formDataToSend.append('rewardAmount', formData.totalRewards);
            }

            if (formData.poolEndDate) {
                // Convert to ISO string format if it's a Date object
                const dateString = formData.poolEndDate instanceof Date
                    ? formData.poolEndDate.toISOString()
                    : formData.poolEndDate;
                formDataToSend.append('poolEndDate', dateString);
            }

            if (gasFees) {
                formDataToSend.append('gasFees', gasFees);
            }

            if (account) {
                formDataToSend.append('walletAddress', account?.toLowerCase());
            }

            if (transactionHash) {
                formDataToSend.append('contractHash', transactionHash?.toLowerCase());
            }
            if (unifarmAddress) {
                formDataToSend.append('contractAddress', unifarmAddress?.toLowerCase());
            }

            // Get access token from localStorage
            const accessToken = localStorage.getItem('accessToken');

            // Prepare headers
            const headers = {};
            if (accessToken) {
                headers['Authorization'] = `Bearer ${accessToken}`;
            }

            // Replace with your actual API endpoint
            const response = await fetch(ApiUrl + '/pool', {
                method: 'POST',
                headers: headers,
                body: formDataToSend,
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || `API call failed: ${response.statusText}`);
            }

            const result = await response.json();
            // console.log('Pool saved to backend:', result);
            setIsSavingPool(false);
            return { success: true, data: result };

        } catch (error) {
            console.error('Failed to save pool to backend:', error);
            setSaveError(error.message);
            setIsSavingPool(false);
            return { success: false, error: error.message };
        }
    };

    return {
        savePoolToBackend,
        isSavingPool,
        saveError
    };
};

export default usePoolAPI;